var React = require('react');

function RadioChecked16x16 (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1","y":"1.5","width":"14","height":"14","rx":"7","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("rect",{"x":"5","y":"5.5","width":"6","height":"6","rx":"3","fill":"currentColor","key":1})]);
}

RadioChecked16x16.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = RadioChecked16x16;

RadioChecked16x16.default = RadioChecked16x16;
